
export const findItem = (list, id, type) => {
  for (let i = list.length - 1; i >= 0; i--) {
    const item = list[i];

    if ((item.type == type || item.type == null) && item.id == id) {
      return item;
    }

    if (item.type == 'group' && item.children) {
      for (let j = item.children.length - 1; j >= 0; j--) {
        if (item.children[j] && item.children[j].type == type && item.children[j].id == id) {
          return item.children[j];
        }
      }
    }
  }
};

export default findItem;



// WEBPACK FOOTER //
// ./src/app/util/groupStructureHelpers.js